/// <reference path="app.ts" />

module Meevo {
    'use strict';

    function setUserLocalAddress(identityService: Meevo.Components.Common.IIdentityService, $window: any): void {

        var doNothing = () => { };

        // detect RTCPeerConnection constructor including prefixed names for Firefox and Chrome
        var peerConnectionConstructor =
            $window.RTCPeerConnection || $window.mozRTCPeerConnection || $window.webkitRTCPeerConnection;

        if (!peerConnectionConstructor) {
            // RTCPeerConnection is not supported by the browser
            identityService.current().userLocalAddress = "0.0.0.0";
            return;
        }

        var peerConnection = new peerConnectionConstructor({ iceServers: [] });

        // create a dummy data channel
        peerConnection.createDataChannel("");

        // create offer and set local description
        peerConnection.createOffer(peerConnection.setLocalDescription.bind(peerConnection), doNothing);

        // listen for candidate events
        peerConnection.onicecandidate = function (ice) {
            if (!ice || !ice.candidate || !ice.candidate.candidate) {
                return;
            }

            const matches = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate);
            if (matches && matches.length > 1) {
                identityService.current().userLocalAddress = matches[1];
            }
            peerConnection.onicecandidate = doNothing;
        };
    }

    function run($window: any,
        $state: angular.ui.IStateService,
        $rootScope: any,
        $filter: angular.IFilterService,
        appSettings: Meevo.Components.Common.IAppSettings,
        dataService: Meevo.Components.Common.ICommonDataService,
        identityService: Meevo.Components.Common.IIdentityService,
        modalService: Meevo.Components.Modal.IModalService,
        trackingService: Meevo.Components.Tracking.ITrackingService,
        pushMessageHandler: any,
        $translate: angular.translate.ITranslateService,
        tmhDynamicLocale: any,
        $mdDateLocale: any,
        $locale: angular.ILocaleService,
        ngIntlTelInput: any,
        interopService: any): void {

        Handlebars.registerHelper('format', function (context: any, options) {
            var type = options.hash.type;
            switch (type) {
                case 'phone':
                    return $filter<any>('meevoPhoneNumber')(context);
                case 'phoneFormat':
                    return $filter<any>('meevoPhoneNumberFormat')(context, options.hash.countryCode);
                case 'phoneLastFour':
                    return $filter<any>('meevoPhoneNumberLastFourFilter')(context);
                default:
                    return;
            }
        });

        device.largeTablet = () => {
            return device.tablet() && window.innerWidth >= 1024;
        };

        device.standalone = () => {
            return device.ios() && window.navigator["standalone"];
        };

        /*
        *   $rootScope.MEEVOCDN Used by gulp task 'dist-templatecache-meevocdn'
        *   to append url src so assets are served from cloud
        *   $window.MEEVOCDN
        */
        $rootScope.MEEVOCDN = $window.MEEVOCDN || '';

        /**
         *  https://github.com/lgalfaso/angular-dynamic-locale
         *  @param tmhDynamicLocale
         *  Fired when defaultLocale changed in app.config
         */
        $rootScope.$on('$localeChangeSuccess', () => {
            /*  Do Something Else*/
        });

        var getStartDayOfWeek = (dayEnum: number): number => {

            let startDayOfWeek=0;
            switch (dayEnum) {
                case Meevo.Model.WeekdayNameEnum.Sunday:
                    startDayOfWeek = 0;
                    break;
                case Meevo.Model.WeekdayNameEnum.Monday:
                    startDayOfWeek = 1;
                    break;
                case Meevo.Model.WeekdayNameEnum.Tuesday:
                    startDayOfWeek = 2;
                    break;
                case Meevo.Model.WeekdayNameEnum.Wednesday:
                    startDayOfWeek = 3;
                    break;
                case Meevo.Model.WeekdayNameEnum.Thursday:
                    startDayOfWeek = 4;
                    break;
                case Meevo.Model.WeekdayNameEnum.Friday:
                    startDayOfWeek = 5;
                    break;
                case Meevo.Model.WeekdayNameEnum.Saturday:
                    startDayOfWeek = 6;
                    break;
            }

            return startDayOfWeek;
        }

        const settingsPromise = dataService.customMethodData("api/Tenant/BusinessInfo/Settings", "get", {}).then((response) => {
            appSettings.APP_BUSINFOSETTINGS = response.data;
            $rootScope.appointmentBookSettings = response.data.appointmentBookSettings;
            $rootScope.clientsSettings = response.data.clientsSettings;
        }, (error: any) => {
            console.log(error);
        });

        /*
        *   Culture Settings
        *   Update $translate - moment.js - mdDatePicker - locale
        */
        settingsPromise.then(() => {
            dataService.customMethodData("api/settings/cultural", "GET", null).then((settings: any) => {
                let countryEnum = settings.data.countryEnum;
                let onlyCountries = [];
                for (var countryId in Meevo.Model.CountryIdEnum) {
                    if (!Number(Meevo.Model.CountryIdEnum[countryId])) {
                        onlyCountries.push(Meevo.Model.CountryIdEnum[countryId].substr(3));
                    }
                }
                // let cultureId = Meevo.Model.CountryIdEnum[countryEnum].replace('_', '-');
                let cultureId = settings.data.locale;
                let metadataId = cultureId.substr(3).toUpperCase();
                appSettings.APP_TIME_FORMAT = settings.data.timeFormatEnum;
                appSettings.APP_CURRENCY = appSettings.APP_COUNTRIES[metadataId]['Currency'] || appSettings.APP_CURRENCY;
                appSettings.APP_ISOCURRENCYCODE = appSettings.APP_COUNTRIES[metadataId]['IsoCurrencyCode'] || appSettings.APP_ISOCURRENCYCODE;
                appSettings.APP_ISOCOUNTRYCODE = appSettings.APP_COUNTRIES[metadataId]['IsoCountryCode'] || appSettings.APP_ISOCOUNTRYCODE;
                appSettings.APP_LANGUAGEID = appSettings.APP_COUNTRIES[metadataId]['LanguageId'] || appSettings.APP_LANGUAGEID;

                let isTimeFormat24 = Meevo.Model.TimeFormatEnum.TimeFormat24 === appSettings.APP_TIME_FORMAT;

                tmhDynamicLocale.set(cultureId).then(() => {
                    /** Normalize locale pre-defined DATETIME_FORMATS to support am/pm as in angular-locale_en-us.js.
                     *  Overrides current locale | medium | mediumTime | shortTime | shortTime | formats to support app TimeFormat24
                     */
                    let addlDateTimeFormats: any = {};
                    let dateTimeFormats: any = $locale.DATETIME_FORMATS;
                    _.each($locale.DATETIME_FORMATS, (df: any, i: any) => {
                        if (!isObject(df) && typeof df === 'string') {
                            if (_.contains(df, 'H') || _.contains(df, 'h')) {
                                if (isTimeFormat24) {
                                    dateTimeFormats[i] = df.replace('a', '');
                                    dateTimeFormats[i] = dateTimeFormats[i].replaceAll('h', 'H');
                                } else {

                                    dateTimeFormats[i] += _.contains(df, 'H') ? ' a' : '';
                                    dateTimeFormats[i] = dateTimeFormats[i].replaceAll('H', 'h');
                                }
                            }
                            if (_.contains(df, 'Y') || _.contains(df, 'y')) {
                                let withNoYear = df.replace(/([^EMdHhmsa]*)([Yy]+)([^EMdHhmsa]*)/, " ").replace("  ", " ").trim();
                                if (withNoYear != df) {
                                    addlDateTimeFormats[i + "WithoutYear"] = withNoYear;
                                }
                            }
                        }
                    })
                    $locale.DATETIME_FORMATS = _.extend(dateTimeFormats, addlDateTimeFormats);

                    appSettings.APP_AMPMS = $locale.DATETIME_FORMATS.AMPMS || appSettings.APP_AMPMS;
                    appSettings.APP_COUNTRYID = $locale.id || appSettings.APP_COUNTRYID;
                    let countryId = $locale.id.substr(3);
                    ngIntlTelInput.set({
                        initialCountry: countryId,
                        preferredCountries: onlyCountries
                    });
                    const USEnglish = 'en-us';
                    const GBEnglish = 'en-gb';
                    const Americas = ['en-us', 'en-ca', 'en-tt', 'es-mx'];
                    let languages = _.contains(Americas, $locale.id) ? [$locale.id, USEnglish] : [$locale.id, GBEnglish, USEnglish];
                    languages = _.uniq(languages);
                    $translate.fallbackLanguage(languages);
                    $translate.use($locale.id);

                    /**
                     * Moment.js unexpected behavior for some locales => if 'ar-bh' then switch to 'en-gb'(default arabic format)
                     */
                    const unsupportedLocales = ['ar-bh', 'en-gi'];
                    let momentLocaleId = _.contains(unsupportedLocales, $locale.id) ? GBEnglish : $locale.id;
                    moment.locale(momentLocaleId);

                    $mdDateLocale.shortMonths = $locale.DATETIME_FORMATS.SHORTMONTH;
                    $mdDateLocale.months = $locale.DATETIME_FORMATS.MONTH;
                    $mdDateLocale.shortMonths = $locale.DATETIME_FORMATS.SHORTMONTH;
                    $mdDateLocale.days = $locale.DATETIME_FORMATS.DAY;
                    $mdDateLocale.shortDays = $locale.DATETIME_FORMATS.SHORTDAY;

                    $mdDateLocale.parseDate = (dateString) => {
                        var m = moment(dateString, 'L', true);
                        return m.isValid() ? m.toDate() : new Date(NaN);
                    };
                    $mdDateLocale.formatDate = (date) => {
                        var m = moment(date);
                        return m.isValid() ? m.format('L') : '';
                    };

                    const startDayOfWeek = getStartDayOfWeek(appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings.startAppointmentBookDayOn);
                    $mdDateLocale.firstDayOfWeekLocale = moment()['_locale']['_week']['dow'];
                    moment.locale(moment.locale(), <any>{ week: { dow: startDayOfWeek } });
                    $mdDateLocale.firstDayOfWeek = startDayOfWeek;
                });

            }, (error: any) => {
                console.log(error);
            });
        });

        $rootScope.$on(Meevo.Components.Common.Messages.AUTHENTICATION_SUCCESS, (event: angular.IAngularEvent, data: Meevo.Components.Common.IIdentity) => {
            const hasEmail = !!identityService.current().emailAddress;
            const isMSIUser = identityService.current().userTypeEnum === Model.UserTypeEnum.MSIUser;
            settingsPromise.then(() => {
                if (!isMSIUser &&
                    appSettings.APP_BUSINFOSETTINGS.usersSettings &&
                    appSettings.APP_BUSINFOSETTINGS.usersSettings.requireEmailAddress &&
                    !hasEmail) {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: "app/components/email/email.html",
                        controller: "meevo.email.EmailController",
                        controllerAs: "email",
                        bindToController: true,
                        clickOutsideToClose: true
                    }
                    modalService.showCustom(options);
                }
            });

            if (data.requiresPunchIn) {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/requireClockIn/requireClockIn.html",
                    locals: {
                        model: data
                    },
                    controller: "meevo.requireClockIn.RequireClockInController",
                    controllerAs: "requireClockIn",
                    bindToController: true
                }
                modalService.showCustom(options)
                    .then((result) => {
                    });
            }
            
            // START: DataDog
            if ($window.DD_RUM) {
                const identity = identityService.current();

                $window.DD_RUM.setUser({
                    id: identity.userId,
                    name: identity.userName,
                    email: identity.emailAddress,
                    sessionId: identity.id,
                    location: identity.locationId,
                    locationName: identity.locationName,
                    tenant: identity.tenantId
                });
            }
            // END: Datadog

            // TODO: restore this TrackJS code clobbered by Meevo Theming
            // START: TrackJS - Configure tracking so requests can be correlated to the user.
            /*
            if ($window.trackJs) {

                let identity = identityService.current();

                $window.trackJs.configure({
                    userId: identity.userName + " |userId: " + identity.userId,
                    sessionId: identity.id + "|location:" + identity.locationId
                });

                //$window.trackJs.addMetadata("tenantId", identity.tenantId);
                //$window.trackJs.addMetadata("tenant", identity.tenantName);
                //$window.trackJs.addMetadata("locationId", identity.locationId);
                $window.trackJs.addMetadata("location", identity.locationName);
                //$window.trackJs.addMetadata("userName", identity.userName);
            }
            */
            // END: //TrackJS

            // Gets custom theming
            // Gets theme colors from amazon s3
            let tenantId = !!data.tenantId ? data.tenantId : identityService.current().tenantId;

            if (!!tenantId) {

                dataService.getThemeCss(tenantId).then(res => {
                    if (!res) {
                        return;
                    }
                    const head = document.getElementsByTagName('head')[0];
                    const style = document.createElement('style');
                    const noTransitionStyle = document.createElement('style');
                    let cssFile = "";
                    for (let key in res['css']) {
                        cssFile += res['css'][key];
                    }

                    let responseStr = cssFile;
                    let noTransitionResponse = responseStr.replace("transition", "no-transition");

                    noTransitionStyle.type = 'text/css';
                    style.type = 'text/css';
                    style.appendChild(document.createTextNode(responseStr));
                    noTransitionStyle.appendChild(document.createTextNode(noTransitionResponse))
                    head.appendChild(style);
                    //removing transition proerty
                    //head.removeChild(style);
                    //head.appendChild(noTransitionStyle)
                }).catch(err => { console.log(err); });
            }

            checkPasswordAndTimezone();
            $rootScope.$broadcast(Meevo.Components.Common.Messages.SESSION_COUNTDOWN);
        });

        var initializePendo = (locationData: any, msiUser: boolean) => {
            // START: Pendo
            const pendoUrl = window['PendoUrl'];
            const pendoApiKey = window['PendoApiKey'];
            const effectivePendoUserId = msiUser ? identityService.current().userName : identityService.current().userId;
            if (!pendoUrl || !pendoApiKey) return;

            (function (url, key) {
                (function (p, e, n, d, o) {
                    var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || [];
                    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
                        o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
                    })(v[w]);
                    y = e.createElement(n); y.async = !0; y.src = url + '/' + key + '/pendo.js';
                    z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
                })(window, document, 'script', 'pendo');

            })(pendoUrl, pendoApiKey);
            const tenantId = identityService.current().tenantId;
            const origin = $window.location.origin;
            $window.pendo.initialize({
                visitor: {
                    id: `${identityService.inTestOrTrainingMode() ? 'lower_' : ''}${effectivePendoUserId}`,
                    visitorId: `${identityService.inTestOrTrainingMode() ? 'lower_' : ''}${effectivePendoUserId}`,
                    email: identityService.current().emailAddress,
                    user_data: effectivePendoUserId + '|' + tenantId + '|' + identityService.current().locationId,
                    userName: identityService.current().userName,
                    fullAccess: identityService.current().fullAccess,
                    salesForceId: identityService.current().salesForceId,
                    locationSalesForceId: locationData.salesForceId,
                    learningTrack: identityService.current().LearningTrack,
                    full_name: identityService.current().displayName,
                    tenantId: tenantId,
                    url: `${origin}/login/${tenantId}`
                },
                account: {
                    id: identityService.current().locationId,
                    name: identityService.current().locationName,
                    locationType: identityService.current().isSingleLocation ? 'Single Location' :
                    identityService.current().centralOfficeId === identityService.current().locationId ? 'Central office' : 'Location',
                    locationTimeZone: identityService.current().locationTimeZone,
                    locationSalesForceId: locationData.salesForceId
                }
            });

            // END: Pendo
        }

        var initializeFinMessenger = () => {
            if (!$window.pendo || typeof $window.pendo !== 'object' || typeof $window.pendo.initialize !== 'function') return;

            // Fetch a fresh FinMessenger (Intercom) identity-verification JWT for the
            // current user, then boot the Messenger with it. If the token call fails,
            // fall back to booting without the JWT to preserve prior behavior.
            dataService.customMethodData("api/auth/finmessenger-token", "GET", null)
                .then((response: any) => (response && response.data ? response.data : undefined),
                    (error: any) => { console.log(error); return undefined; })
                .then((intercomData: any) => {
                    $window.intercomSettings = {
                        api_base: 'https://api-iam.intercom.io',
                        app_id: 'lqx113id',
                        messenger_environment: '80slutbfdv',
                        intercom_user_jwt: !!intercomData ? intercomData.token : null,
                        company_id: !!intercomData ? intercomData.customerNumber : null
                    };

                    (function () {
                        var w: any = $window;
                        var ic: any = w.Intercom;
                        if (typeof ic === 'function') {
                            ic('reattach_activator');
                            ic('update', w.intercomSettings);
                        } else {
                            var d = w.document;
                            var i: any = function () { i.c(arguments); };
                            i.q = [];
                            i.c = function (args: any) { i.q.push(args); };
                            w.Intercom = i;
                            var l = function () {
                                var s = d.createElement('script');
                                s.type = 'text/javascript';
                                s.async = true;
                                s.src = 'https://widget.intercom.io/widget/lqx113id';
                                document.body.appendChild(s);
                            };
                            if (d.readyState === 'complete') {
                                l();
                            } else if (w.attachEvent) {
                                w.attachEvent('onload', l);
                            } else {
                                w.addEventListener('load', l, false);
                            }
                        }
                    })();
                });
        }

        var checkPasswordAndTimezone = () => {
            dataService.getIdentity().then((data: Meevo.Components.Common.IIdentity) => {
                var checkForTimeZone = () => {
                    var openTimeZoneModal = (result: any) => {
                        let options: Meevo.Components.Modal.IModalOptions = {
                            templateUrl: "app/components/changeTimeZone/changeTimeZone.html",
                            locals: {
                                model: null,
                                locationTimeZone: result.data.locationTimeZone
                            },
                            controller: "meevo.changeTimeZone.ChangeTimeZoneController",
                            controllerAs: "changeTimeZone",
                            bindToController: true
                        };

                        return modalService.showCustom(options).catch(() => {

                            return modalService.confirm("MESSAGE_CANCEL_TIMEZONE_CONFIRMATION", 0).then(() => {
                                // Yes->logout
                                dataService.logout().then((response: any) => {
                                    let url = identityService.current().sessionTimeoutRedirectUrl;
                                    identityService.setIdentity(null);
                                    $window.onbeforeunload = () => null;
                                    $window.location.href = url;
                                });

                                return false;
                            }).catch(() => {
                                openTimeZoneModal(result);
                            });;
                        });
                    }

                    return dataService.customMethodData(`api/location/${data.locationId}`, "GET", null).then((result) => {
                        if (!result || !result.data) return;

                        if (data.tenantId !== 2 && data.tenantId !== 1 && data.userTypeEnum != 2075) {
                            initializePendo(result.data, data.userTypeEnum === 2084);
                            initializeFinMessenger();
                        } else if (data.tenantId === 1) {
                            // hide help icon for JCP
                            $window.hideConvobarHelpIcon = true;
                        }
                        
                        if (result.data.isTimeZoneConfirmed === false) {
                            openTimeZoneModal(result);
                        }
                        else {
                            return true;
                        }
                    });
                };

                if (data.requireChangePassword) {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: "app/components/changePassword/changePassword.html",
                        locals: {
                            model: null,
                            userId: data.userId,
                            userName: data.userAuthName,
                            requireChangePassword: data.requireChangePassword
                        },
                        controller: "meevo.changePassword.ChangePasswordController",
                        controllerAs: "changePassword",
                        bindToController: true
                    };

                    return modalService.showCustom(options).then((result) => { return checkForTimeZone() });
                } else {
                    return checkForTimeZone();
                }
            }).catch((err) => {
                console.log(err);
            });
        }

        $rootScope.$on(Meevo.Components.Common.Messages.REFRESH_IDENTITY, (event: angular.IAngularEvent, broadcast: boolean = false) => {

            dataService.refreshIdentity(identityService.locationId)
                .then(() => dataService.getIdentityFull())
                .then((response) => {
                    identityService.setIdentity(response);
                    if (broadcast)
                        $rootScope.$broadcast(Meevo.Components.Common.Messages.AUTHENTICATION_SUCCESS, identityService.current());
                })
                .catch((err) => {
                    /*  Broadcast "REFRESH_IDENTITY" Is Called From main.controller. Catch Errors In A Slow Network Environment, Will Result In Expired Session */
                    $rootScope.$broadcast(Meevo.Components.Common.Messages.SESSION_TIMEOUT_HANDLER, Meevo.Model.SessionState.Lockout, 'RefreshIdentity');
                });
        });

        // Retrieve information from session and populate identity.
        dataService.getIdentityFull().then((data: Meevo.Components.Common.IIdentity) => {

            identityService.setIdentity(data);
            appSettings.SERVER_EVENTS_ENABLED ? pushMessageHandler.initiate(identityService.current().locationId) : null;
            if (data.isAuthenticated) {
                //if (Model.Guard.isSomething($window))
                setUserLocalAddress(identityService, $window);
                $rootScope.$broadcast(Meevo.Components.Common.Messages.AUTHENTICATION_SUCCESS, identityService.current());
            } else {
                if (data.locationId > 0) {
                    this.$window.location.href = appSettings.LOGIN_URL + "?locationid=" + data.locationId;
                } else {

                    var tenantId = this.$window.location.search.split('tenantId=')[1];
                    if (tenantId.search("status") > 0) {
                        tenantId = decodeURIComponent(tenantId);
                        this.$window.location.href = tenantId;
                    }
                   else 
                        this.$window.location.href = "login" + `/${tenantId}`;
                    }
            }
        }).catch((err) => {
            console.log( err);
        });

        $rootScope.$on(Meevo.Components.Common.Messages.STATE_CHANGE_SUCCESS,
            (event, toState, toParams, fromState, fromParams) => {
                let noun: any = toState.hasOwnProperty("noun") ? toState.noun : (Meevo.Model as any).NounEnum.NotSpecified;
                trackingService.savePageView(noun);
            });
    }

    angular.module('meevo').run([
        "$window",
        "$state",
        "$rootScope",
        "$filter",
        "meevo.AppSettings",
        "meevo.components.common.DataService",
        "meevo.components.common.IdentityService",
        "meevo.components.modal.ModalService",
        "meevo.components.tracking.TrackingService",
        "meevo.components.common.meevoPushMessageHandler",
        "$translate",
        "tmhDynamicLocale",
        "$mdDateLocale",
        "$locale",
        "ngIntlTelInput",
        "meevo.plugins.interop.InteropService",
        run,
    ]);
}